import classes from "./styles.module.scss";
import clsx from "classnames";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { AccordionItem, Description, Title } from "@/ui";

export const Accordion = ({ className, title, description, items }) => {
  const [active, setActive] = useState();

  return (
    <div className={clsx(className, classes.accordion)}>
      <Container>
        <Title title={title} />
        <Description className="mb-4" description={description} />
        {items.map(({ title, body }, k) => (
          <AccordionItem
            key={k}
            eventKey={k}
            title={title}
            body={body}
            active={k === active}
            onClick={() => setActive(k === active ? null : k)}
          />
        ))}
      </Container>
    </div>
  );
};

export default Accordion;